import '@css/Map.css'
import 'mapbox-gl/dist/mapbox-gl.css'

import type { AppState } from '@constants/types'
import { setYachtTransformation } from '@constants/utils'
import { mekkaLocation } from '@containers/MekkahPage'
import Grid from '@mui/material/Grid'
import { styled } from '@mui/material/styles'
import type { Map } from 'mapbox-gl'
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import { createMapboxLngLatBounds, drawMekkah } from '../Maps/Mapbox/mapbox_helpers'
import MapboxPolyline from '../Maps/Mapbox/MapboxPolyline'
import MapboxWrapper from '../Maps/Mapbox/MapboxWrapper'

const MapContainer = styled(Grid)({
  position: 'absolute',
  right: '8vw',
  top: 0,
  width: '25vw',
  height: '25vw',
  border: '.2rem solid #33C1FA',
  borderRadius: '50%',
  transform: 'translateY(-50%)',
  overflow: 'hidden'
})

const StyledMapboxWrapper = styled(MapboxWrapper)({
  borderRadius: '50%'
})

const MekkahView = () => {
  const mapInstance = useRef<Map | null>(null)
  const position = useSelector((state: AppState) => state.main)
  const [heading, setHeading] = useState(0)

  const arcShape = MapboxPolyline.arc(position.position.value, mekkaLocation, 70)

  const fitMapBounds = () => {
    if (mapInstance.current) {
      try {
        const bounds = createMapboxLngLatBounds([position.position.value, mekkaLocation])
        mapInstance.current.fitBounds(bounds, {
          padding: window.innerWidth * 0.05
        })
      } catch (e) {
        console.error(`unable to create LngLatBounds: ${e}`, 'current position', position.position.value)
      }
    }
  }

  const onMapLoaded = (map: Map) => {
    mapInstance.current = map
    fitMapBounds()
    drawMekkah(map)
  }

  const updateYachtTransformation = () => {
    if (mapInstance.current) {
      setYachtTransformation(mapInstance.current, heading)
    }
  }

  useEffect(() => {
    setHeading(position.heading.value)
    fitMapBounds()
  }, [position])

  useEffect(() => {
    updateYachtTransformation()

    const id = setInterval(updateYachtTransformation, 20000)

    return () => {
      clearInterval(id)
    }
  }, [])

  return <MapContainer>
    <StyledMapboxWrapper
      mode="mapbox2d"
      id="mekkah-map"
      interactive={false}
      center={position.position.value}
      onLoaded={onMapLoaded}
      polylines={[arcShape]}
      showPulsatingIcon
    />
  </MapContainer>
}

export default MekkahView
